import { render } from "./CustomerDashboard.vue?vue&type=template&id=725167e6&scoped=true"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js"

import "./CustomerDashboard.vue?vue&type=style&index=0&id=725167e6&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukatta_Gov_Eticket\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725167e6"]])

export default __exports__